import { createGrowingDecliningDirectionToTagMap } from "app/pages/sales-intelligence/sub-modules/signals/constants/signalDirectionToTagMap";
import TrafficChangesTrend from "app/pages/sales-intelligence/sub-modules/signals/models/traffic/TrafficChangesTrend";

export const NEW_MARKETS_TAG = "New market";

export const trafficChangesDirectionToTagMap = createGrowingDecliningDirectionToTagMap({
    grew: TrafficChangesTrend.Grew,
    declined: TrafficChangesTrend.Declined,
});
